<template>
  <a-layout-content class="p-all">
    <a-row :gutter="{xs:0, lg:8}">
      <a-col :xs="24" :lg="8">
        <a-card>
          <span class="m-text-title" slot="title">Filter</span>
          <div class="d-flex flex-column">
            <a-input-search v-model="search" placeholder="Pencarian ... " />
            <a-collapse activeKey="1" class="m-top">
              <a-collapse-panel key="1">
                <span slot="header">Cari Lebih Lengkap</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Tanggal Transaksi</label>
                  <a-date-picker
                    v-model="transactionDt"
                    @change="searching"
                    :format="getDefaultDateFormat"
                    allowClear
                  />
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    @change="searching"
                    class="w-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option value="delivered">Delivered</a-select-option>
                    <a-select-option value="approved">Approved</a-select-option>
                    <a-select-option value="on process">On Process</a-select-option>
                    <a-select-option value="revised">Revised</a-select-option>
                    <a-select-option value="rejected">Rejected</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </a-card>
      </a-col>
      <a-col :xs="24" :lg="16">
        <H-Datalist
          title="Daftar Permohonan Cuti"
          createLink="createSppd"
          manifestLink="manifestCuti"
          editLink="edit"
          :dataList="basedData"
        >
          <div slot="action-button">
            <a-button type="primary" @click="handleCreate('Create')">
              <a-icon type="plus" />
              &nbsp;{{isMobile ? '' : 'Permohonan Cuti'}}
            </a-button>
          </div>
          <template slot="change-button" slot-scope="{item}">
            <a-button type="danger" @click="handleCreate(item)">
              <a-icon type="edit" />&nbsp; Ubah Data
            </a-button>
          </template>
        </H-Datalist>
      </a-col>
    </a-row>

    <a-modal
      title="Buat Permohonan Cuti"
      :visible="visible"
      @cancel="handleCancel"
      :maskClosable="false"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Return</a-button>
        <a-button
          key="submit"
          :disabled="disable"
          type="primary"
          :loading="loading"
          @click="handleOk"
        >Submit</a-button>
      </template>
      <a-form class="m-form" :form="form">
        <a-form-item label="Sisa Cuti">
          <a-input disabled v-decorator="['sisa_cuti', {initialValue: initialData.sisaCuti}]" />
        </a-form-item>
        <a-form-item label="Tanggal Cuti">
          <vc-date-picker
            locale="id"
            :min-date="tigaHari(mode === 'Create' ? new Date() : new Date(rubahData.data.tgl_buat), 3)"
            :disabled-dates="{ weekdays: [1, 7] }"
            :select-attribute="selectAttribute"
            v-model="dates"
            mode="multiple"
            color="green"
            is-inline
            is-expanded
          />
        </a-form-item>
        <a-form-item label="Keperluan">
          <a-input
            v-decorator="['keperluan', {initialValue: initialData.keperluan, rules: [{required: true}]}]"
          />
        </a-form-item>
        <a-form-item label="Approval">
          <a-select
            :disabled="mode === 'Edit' ? true : false"
            v-decorator="['approval',{initialValue: initialData.approval, rules: [{required: true}]}]"
          >
            <a-select-option
              v-for="item in getCuti.approval"
              :key="item.tlc"
            >{{item.tlc + ' - ' + item.nama}}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-layout-content>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import DataList from "@/components/Datalist";
import moment from "moment";
export default {
  components: {
    "H-Datalist": DataList
  },
  name: "cuti",
  data() {
    return {
      cutiList: [],
      basedList: [],
      workingDay: [1, 2, 3, 4, 5],
      visible: false,
      transactionDt: null,
      search: "",
      status: "",
      dates: [],
      loading: false,
      disable: false,
      mode: "Create",
      rubahData: {},
      selectAttribute: {
        dot: true
      },
      id_cuti: ""
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.fetchData();
    this.FETCH_CUTI(this.getAuth.username);
  },
  watch: {
    dates() {
      if (this.mode === "Create") {
        if (this.dates.length > this.getCuti.sisa_cuti) {
          this.$notification.warning({
            message: "Error",
            description:
              "Permintaan Cuti Melebihi Batas Cuti Tahunan!"
          });
          this.disable = true;
        } else {
          this.disable = false;
        }
      } else {
        this.disable = false;
      }
    }
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getCuti",
      "getDefaultDateFormat",
      "getStandartFormatDate"
    ]),
    basedData() {
      let output = [];

      this.cutiList.forEach(data => {
        output.push({
          title: data.no_cuti,
          subdesc: [
            [
              { label: "Tanggal Transaksi ", value: data.tgl_buat },
              { label: "Cuti yang diambil ", value: data.cuti_diambil },
            ]
          ],
          description: "Keperluan : " + data.keperluan,
          status: data.status,
          timeline: JSON.parse(data.status_app),
          id: data.id_cuti
        });
      });

      console.log(output);
      return output;
    },
    initialData() {
      if (this.mode === "Create") {
        return {
          sisaCuti: this.getCuti.sisa_cuti,
          tanggal_cuti: moment(this.tigaHari(moment(), 3)).format(
            this.getDefaultDateFormat
          ),
          keperluan: ""
        };
      } else {
        return {
          sisaCuti: this.getCuti.sisa_cuti,
          keperluan: this.rubahData.data.keperluan,
          approval: this.rubahData.data.approval
        };
      }
    },
    searching() {
      this.cutiList = this.basedList;

      if (this.search) {
        this.cutiList = this.cutiList.filter(
          obj =>
            obj.no_cuti.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.tgl_buat.toLowerCase().indexOf(this.search.toLowerCase()) >=
              0 ||
            obj.tgl_cuti.toLowerCase().indexOf(this.search.toLowerCase()) >=
              0 ||
            obj.status.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.keperluan.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.status) {
        this.cutiList = this.cutiList.filter(
          obj =>
            obj.status &&
            obj.status.toLowerCase().indexOf(this.status.toLowerCase()) >= 0
        );
      }

      if (this.transactionDt) {
        let searchDate = moment(this.transactionDt).format(
          this.getStandartFormatDate
        );
        this.cutiList = this.cutiList.filter(
          obj => obj.tgl_buat === searchDate
        );
      }

      if (!this.search && !this.status && !this.transactionDt) {
        this.cutiList = this.basedList;
      }
    }
  },
  mounted() {
    Event.$on("confirmMessageReturn", this.handleOkProcess);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleOkProcess);
  },
  methods: {
    moment,
    ...mapActions({ FETCH_CUTI: "FETCH_CUTI_DETAIL" }),
    async fetchData() {
      await axios({
        method: "get",
        url: this.$serviceUrl + "cuti",
        params: {
          tlc: this.getAuth.username
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.cutiList = response.data.data;
          this.basedList = response.data.data;
        })
        .catch(err => {
          console.log(err.response);
        });
    },
    fetchDetilCuti(value) {
      this.id_cuti = value;
      axios({
        method: "get",
        url: this.$serviceUrl + "cuti/detil_cuti",
        params: {
          tlc: this.getAuth.username,
          id_cuti: value
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.rubahData = {
            data: response.data.data[0],
            cuti_split: response.data.data[0].tgl_cuti.split(",")
          };
          this.rubahData.cuti_split.forEach(date => {
            let convertDate = new Date(date);
            let withoutTime = convertDate.setHours(0, 0, 0, 0);
            this.dates = [...this.dates, new Date(withoutTime)];
          });
          this.visible = true;
        })
        .catch(err => {
          console.log(err.response);
        });
    },
    handleCreate(type) {
      if (type !== "Create") {
        this.mode = "Edit";
        this.fetchDetilCuti(type.id);
      } else {
        this.mode = "Create";
        this.visible = true;
      }
    },
    handleOk() {
      this.confirmMessage("confirm-save");
    },
    handleOkProcess() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        this.loading = true;
        let post = new FormData();

        let formatDate = [];
        let formEdit = [];
        for (let i = 0; i < this.dates.length; i++) {
          formatDate.push(
            moment(this.dates[i]).format(this.getStandartFormatDate)
          );
        }

        post.append("tlc", this.getAuth.username);
        post.append("keperluan", values.keperluan);
        post.append("approval", values.approval);
        post.append("tgl_cuti[]", formatDate);

        if (this.mode === "Edit") {
          formEdit = {
            tlc: this.getAuth.username,
            keperluan: values.keperluan,
            approval: values.approval,
            tgl_cuti: formatDate,
            id_cuti: this.id_cuti
          };
        }

        axios({
          method: this.mode === "Create" ? "post" : "put",
          url: this.$serviceUrl + "cuti",
          processData: false,
          data: this.mode === "Create" ? post : formEdit,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            "Content-Type":
              this.mode === "Create"
                ? "multipart/form-data"
                : "application/json",
            "X-API-KEY": this.getAuth.apikey
          }
        })
          .then(response => {
            if (this.mode === "Edit") {
              this.$notification.success({
                message: "Sukses",
                description: "Data telah berhasil diubah!"
              });
            } else {
              this.$notification.success({
                message: "Sukses",
                description: "Data telah berhasil diproses!"
              });
            }
            this.loading = false;
            this.$router.go({ name: "landingCuti" });
            this.visible = false;
          })
          .catch(err => {
            this.$notification.error({
              message: "Error",
              description: err.response.data.message
            });
            // if (err.response.data.message == "Jatah Cuti Anda Sudah Habis") {
            //   this.$notification.error({
            //     message: "Error",
            //     description:
            //       "Jatah Cuti Kamu Sudah Habis, Kamu Tidak Bisa Melakukan Permohonan Cuti ... "
            //   });
            // }

            this.loading = false;
          });
      });
    },
    handleCancel() {
      this.visible = false;
      this.dates = [];
      this.id_cuti = "";
    },
    tigaHari(date, days) {
      date = moment(date);
      while (days > 0) {
        date = date.add(1, "days");
        if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) {
          days -= 1;
        }
      }
      return date._d;
    }
  }
};
</script>

<style>
</style>